import React, { useRef } from 'react'

import { Text } from 'shortcuts/Typography'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

import classNames from 'views/Home/components/MediaPromotion.module.scss'
// import LazyImgwrapper from '@nexys/components/LazyImgWrapper'

const CardMediaVertical = ({ title, description, img, ...restProps }) => {
  const ParentRef = useRef<any>()

  return (
    <div
      onClick={restProps?.onClick}
      className={`flex flex-row ${classNames.containerVerz} box-border`}
      ref={ParentRef}
    >
      <div className={classNames.lazyImgWrapper}>
        <div
          style={{
            height: 100 - 25
          }}
          className={`${classNames.images}`}
        />
      </div>
      <div className={`flex flex-col`}>
        <Text className={classNames.title}>{ title }</Text>
        <Text className={classNames.desc}>{ description }</Text>
      </div>
    </div>
  )
}

export default CardMediaVertical
